<template>
  <el-button
      class="btn-code"
      @click="getCheckCode"
      :disabled="disabled"
  >
    {{ text }}
  </el-button>
</template>

<script setup>
import {computed, onUnmounted, ref} from 'vue';
import request from "@/service/request";
const props = defineProps({
  userName: {
    type: String,
    default: ''
  },
  url: {
    type: String
  },
  telephone: {
    type: String
  }
})
const seconds = ref(0)
const disabled = ref(false);
const text = computed(() => disabled.value ? seconds.value + 's后重发' : '获取验证码')
let url = computed(() => `${props.url}?userName=${props.userName}`)
let phone = computed(() => `${props.url}?phone=${props.telephone}`)
let timer = null;
function getCheckCode(){
  console.log('2222222222222');
  
  if(!props.userName){
    console.log('---------------');
    
    return;
  }
  if (props.telephone == undefined) {
    console.log('登录页面');
  } else {
    console.log('申请页面');
    console.log(props.telephone);
    console.log(props.userName);
    
    url = phone
  }
  console.log('99999999999999');
  
  disabled.value = true;
  request({
    url: url.value,
    method: 'get'
  }).then((data) => {
    if(data.code === 200){
      seconds.value = 60;
      startInterval();
    } else {
      console.log('pppppppppppppppppppp');
      
      this.$message({
          message: '警告哦，这是一条警告消息',
          type: 'warning'
        });    
    }
  }).catch(() => {
    console.log('qqqqqqqqqqqqqqqqqqqqqqqqq');
    disabled.value = false;
  })
}

function startInterval(){
  timer = setInterval(() => {
    if(seconds.value > 0){
      seconds.value = seconds.value - 1;
    }else{
      backToInit();
    }
  }, 1000);
}

function backToInit(){
  clearInterval(timer);
  disabled.value = false;
  seconds.value = 0;
}

onUnmounted(backToInit);
</script>

<style scoped>
.btn-code{
  margin-top: 28px;
  height: 40px;
  width: 112px;
}
</style>